/* Iniciales en violeta sobre accent-100; la foto, si hay, tapa todo. xs 24 · sm 28 · md 40 · lg 56. */
.avatar {
  --_size: var(--h-control-md);
  --_fs: var(--fs-xs);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: var(--_size);
  height: var(--_size);
  border-radius: var(--r-full);
  overflow: hidden;
  background: var(--surface-brand-soft);
  color: var(--text-brand);
}
.avatar[data-tone="solid"] {
  background: var(--surface-brand);
  color: var(--text-inverse);
}
/* Una persona desactivada: gris sobre surface. */
.avatar[data-tone="muted"] {
  background: var(--surface-sunken);
  color: var(--text-subtle);
}
/* Alguien que todavía no existe (invitación pendiente): blanco con borde punteado. */
.avatar[data-tone="dashed"] {
  background: var(--surface-card);
  color: var(--text-subtle);
  border: var(--bw-hair) dashed var(--border-strong);
}
.avatar[data-size="xs"] {
  --_size: var(--s-8);
  --_fs: var(--fs-3xs);
}
.avatar[data-size="sm"] {
  --_size: 28px;
  --_fs: var(--fs-3xs);
}
.avatar[data-size="lg"] {
  --_size: 56px;
  --_fs: var(--fs-lg);
}
.foto {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.iniciales {
  font-family: var(--font-body);
  font-size: var(--_fs);
  font-weight: var(--fw-bold);
  letter-spacing: 0.02em;
  line-height: 1;
}
